import { useRestClient } from '@/contexts/QueryProvider'

type MarkdownDocument = {
  content?: string | null
}

export function getMarkdownContent(data: unknown): string {
  if (typeof data === 'string') {
    return data
  }

  if (data && typeof data === 'object' && 'content' in data) {
    return (data as MarkdownDocument).content ?? ''
  }

  return ''
}

export function useGetTermsMarkdown(appId?: number) {
  const { getMarkdownApiGetTermsAndConditions } = useRestClient()
  return getMarkdownApiGetTermsAndConditions.useSuspenseQuery({ path: { applicationId: appId! } })
}

export function useSaveTermsMarkdown(appId?: number) {
  const { postMarkdownApiSaveTermsAndConditions } = useRestClient()
  return postMarkdownApiSaveTermsAndConditions.useMutation({ path: { applicationId: appId! } })
}

export function useInvalidateTermsMarkdown(appId?: number) {
  const { getMarkdownApiGetTermsAndConditions } = useRestClient()

  return () =>
    getMarkdownApiGetTermsAndConditions.invalidateQueries({
      parameters: { path: { applicationId: appId! } },
    })
}
